(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.enBe = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    domain: '',
    learnMore: {
      logo: {
        alt: 'SAP Logo',
        src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
      },
      text: 'Concur is an SAP Company',
      learn: {
        href: '/sap',
        text: 'Learn more'
      }
    },
    social: [{
      network: 'facebook',
      href: ''
    }, {
      network: 'twitter',
      href: ''
    }, {
      network: 'linkedin',
      href: ''
    }],
    support: {
      links: [
      // {
      //   text: 'CONCUR BLOG',
      //   href: '',
      // },
      {
        text: 'LEGAL DISCLOSURE',
        href: '/legal-disclosure'
      }, {
        text: 'CONTACT',
        href: '/contact'
      }],
      selector: 'COUNTRY/REGION SELECTOR',
      modelTitle: 'Select your location:'
    },
    copyright: {
      text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
      links: [{
        text: 'Privacy Policy',
        href: '/privacy-policy'
      }]
    }
  };
});